import { render, staticRenderFns } from "./Penyedia.vue?vue&type=template&id=4ec93af9"
import script from "./Penyedia.vue?vue&type=script&lang=js"
export * from "./Penyedia.vue?vue&type=script&lang=js"
import style0 from "./Penyedia.vue?vue&type=style&index=0&id=4ec93af9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports